module.exports = __webpack_public_path__ + "media/images/instagram-fd6c899ead4e93ffd95cd96bb4a4b76d.png";